// extracted by mini-css-extract-plugin
export default {"defaultLink":"navlink_defaultLink__vSW-4","active":"navlink_active__0gHEz","uniqueLink":"navlink_uniqueLink__VOb4H"};